// App manifest (E01-S3-T5; contracts 1.0 section 10): an application the shell can host or an MCP
// app it can show. Rule 10 — the human commits — is why `assistant` has no commit or submit
// capability, and must never gain one.
import { z } from "zod";
import { Origin } from "./atlas.js";
import { Id, NonEmpty, PerceptionTier, strictObject, version } from "./primitives.js";
export const HostedApp = strictObject({
    startUrl: z.url({ protocol: /^https?$/ }),
    origins: z.array(Origin).min(1),
    authOrigins: z.array(Origin).optional(),
    partition: NonEmpty,
    atlas: Id.optional(), // the pack id whose atlas applies
    signIn: z.enum(["sso", "interactive"]),
}).superRefine((h, ctx) => {
    let origin = null;
    try {
        origin = new URL(h.startUrl).origin;
    }
    catch {
        // z.url already reported it
    }
    if (origin !== null && !h.origins.includes(origin))
        ctx.addIssue({
            code: "custom",
            message: `startUrl's origin ${origin} is not one of origins`,
            path: ["startUrl"],
        });
});
export const McpApp = strictObject({ server: NonEmpty, uiResources: z.array(NonEmpty) });
/** What the assistant may do in this app. There is no commit, submit or approve capability. */
export const AppAssistant = strictObject({
    perception: PerceptionTier,
    point: z.boolean(),
    navigate: z.boolean(),
});
const common = {
    v: version(1),
    id: Id,
    name: NonEmpty,
    icon: NonEmpty,
    assistant: AppAssistant,
    entitlement: NonEmpty.optional(),
};
/** kind hosted requires `hosted` and has no `mcp`; kind mcp-app the reverse (strict objects reject the other). */
export const AppManifest = z.discriminatedUnion("kind", [
    strictObject({ ...common, kind: z.literal("hosted"), hosted: HostedApp }),
    strictObject({ ...common, kind: z.literal("mcp-app"), mcp: McpApp }),
]);
//# sourceMappingURL=app-manifest.js.map